import { Flex, Text, Badge, Button } from "@radix-ui/themes";

export const runtimeLabel = (value) => value === null || value === undefined ? "Not confirmed" : value ? "Enabled" : "Disabled";

export function AssistantStatus({ settings }) {
  return (
    <Flex direction="column" gap="3">
      <Flex justify="between" gap="4"><Text color="gray">Desired state</Text><Text weight="medium">{settings.enabled ? "Enabled" : "Disabled"}</Text></Flex>
      <Flex justify="between" gap="4"><Text color="gray">Last confirmed runtime state</Text><Text weight="medium">{runtimeLabel(settings.runtime_enabled)}</Text></Flex>
      <Flex justify="between" gap="4"><Text color="gray">Synchronization</Text>
        <Badge color={settings.sync_status === "error" ? "red" : settings.sync_status === "synced" ? "green" : "gray"}>
          {{ synced: "Synchronized", pending: "Pending", error: "Error", unconfigured: "Not configured" }[settings.sync_status] || "Not configured"}
        </Badge>
      </Flex>
    </Flex>
  );
}

export function AssistantLoadError({ error, onRetry }) {
  return (
    <Flex direction="column" gap="3" role="alert">
      <Text>{error?.response?.status === 403 ? "Only organisation Owners can access AI Assistant settings." : "AI Assistant settings could not be loaded. Please try again."}</Text>
      <Button variant="soft" onClick={onRetry}>Try again</Button>
    </Flex>
  );
}
